/*
 * Litte — carrusel infinito (endless loop)
 *
 * Clona los ultimos N elementos al inicio y los primeros N al final.
 * Al llegar a un extremo salta de forma instantanea a la posicion
 * equivalente del bloque real: como el contenido es identico, el salto
 * es invisible y el desplazamiento se siente continuo.
 *
 * Contrato de marcado:
 *   [data-lc-root]                 contenedor
 *     [data-lc-track]              pista con scroll (hijos = items)
 *     [data-lc-prev] [data-lc-next] botones
 *   data-lc-per-view en la pista   items visibles en desktop
 */
(function () {
  'use strict';
  if (window.LitteCarousel) return;

  var RESIZE_WAIT = 180;
  var SETTLE_WAIT = 140;
  var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function posIn(track, el) {
    return el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
  }

  function setInstant(track, x) {
    if (Math.abs(track.scrollLeft - x) < 0.5) return; // sin cambio: no dispara scroll, no marcar bandera
    var prev = track.style.scrollBehavior;
    track.style.scrollBehavior = 'auto';
    track.__lcSelfScroll = true; // marca la escritura como propia
    track.scrollLeft = x;
    void track.offsetWidth; // fuerza reflow para que el smooth siguiente parta de aqui
    track.style.scrollBehavior = prev || '';
  }

  function markClone(node) {
    node.setAttribute('data-lc-clone', '');
    node.setAttribute('aria-hidden', 'true');
    node.setAttribute('tabindex', '-1');
    return node;
  }

  function initRoot(root) {
    if (root.hasAttribute('data-lc-ready')) return;
    var track = root.querySelector('[data-lc-track]');
    if (!track) return;
    root.setAttribute('data-lc-ready', '');

    var prevBtn = root.querySelector('[data-lc-prev]');
    var nextBtn = root.querySelector('[data-lc-next]');
    var state = { loop: false, start: 0, span: 0 };

    function realItems() {
      return Array.prototype.filter.call(track.children, function (el) {
        return el.nodeType === 1 && !el.hasAttribute('data-lc-clone');
      });
    }

    function stride(items) {
      if (!items.length) return track.clientWidth || 1;
      if (items.length > 1) {
        var d = posIn(track, items[1]) - posIn(track, items[0]);
        if (d > 1) return d;
      }
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return items[0].getBoundingClientRect().width + gap;
    }

    function showArrows(on) {
      [prevBtn, nextBtn].forEach(function (b) {
        if (!b) return;
        if (on) { b.removeAttribute('hidden'); b.disabled = false; }
        else { b.setAttribute('hidden', ''); }
      });
    }

    function clearClones() {
      var clones = track.querySelectorAll('[data-lc-clone]');
      for (var i = 0; i < clones.length; i++) clones[i].parentNode.removeChild(clones[i]);
    }

    function setup() {
      clearClones();
      state.loop = false;

      var items = realItems();
      var n = items.length;
      if (n < 2) { showArrows(false); return; }

      setInstant(track, 0);
      // Si el contenido real cabe en la vista no hay nada que rotar.
      if (track.scrollWidth <= track.clientWidth + 1) { showArrows(false); return; }
      showArrows(true);

      var st = stride(items);
      var perView = parseInt(track.getAttribute('data-lc-per-view'), 10) || 5;
      var needed = Math.ceil(track.clientWidth / (st || 1));
      var count = Math.min(n, Math.max(perView, needed) + 1);

      var head = document.createDocumentFragment();
      for (var i = n - count; i < n; i++) head.appendChild(markClone(items[i].cloneNode(true)));
      var tail = document.createDocumentFragment();
      for (var j = 0; j < count; j++) tail.appendChild(markClone(items[j].cloneNode(true)));

      track.insertBefore(head, track.firstChild);
      track.appendChild(tail);

      var firstTail = items[n - 1].nextElementSibling;
      state.start = posIn(track, items[0]);
      state.span = firstTail ? posIn(track, firstTail) - state.start : track.scrollWidth;
      state.loop = state.span > 1;

      setInstant(track, state.start);
    }

    // Normaliza cualquier posicion a su equivalente dentro del bloque real.
    function normalize() {
      if (!state.loop || state.span <= 1) return;
      var x = track.scrollLeft;
      var off = (x - state.start) % state.span;
      if (off < 0) off += state.span;
      var y = state.start + off;
      if (Math.abs(y - x) > 1) setInstant(track, y);
    }

    function go(dir) {
      var items = realItems();
      var st = stride(items) || track.clientWidth;
      if (state.loop) {
        // Reposiciona ANTES de animar: el salto ocurre sobre contenido
        // identico, asi que no se ve, y la animacion nunca choca con el borde.
        if (dir > 0) {
          var maxReal = state.start + state.span - track.clientWidth;
          if (track.scrollLeft >= maxReal - 2) setInstant(track, track.scrollLeft - state.span);
        } else if (track.scrollLeft <= state.start + 2) {
          setInstant(track, track.scrollLeft + state.span);
        }
      }
      // Con 'reducir movimiento' se cambia de slide sin deslizamiento animado.
      track.scrollBy({ left: dir * st, behavior: REDUCE ? 'auto' : 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

    var settleTimer;
    function onScroll() {
      if (!state.loop) return;
      // Ignora el evento que dispara nuestro propio reposicionamiento.
      if (track.__lcSelfScroll) { track.__lcSelfScroll = false; return; }
      clearTimeout(settleTimer);
      settleTimer = setTimeout(normalize, SETTLE_WAIT);
    }
    track.addEventListener('scroll', onScroll, { passive: true });

    var resizeTimer;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(remeasure, RESIZE_WAIT);
    }
    window.addEventListener('resize', onResize);

    // Re-mide conservando el item visible (las imagenes alteran las medidas).
    function remeasure() {
      var idx = 0;
      if (state.loop) {
        var s = stride(realItems()) || 1;
        idx = Math.round((track.scrollLeft - state.start) / s);
      }
      setup();
      if (state.loop) {
        var s2 = stride(realItems()) || 1;
        setInstant(track, state.start + idx * s2);
        normalize();
      }
    }

    setup();
    function onLoad() { remeasure(); }
    window.addEventListener('load', onLoad);

    // ResizeObserver: re-mide cuando cambian las dimensiones del track
    // (imagenes que cargan tarde, o secciones inyectadas tras el 'load' del editor).
    var ro = null, roInit = false;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(function () {
        if (!roInit) { roInit = true; return; } // ignora la medicion inicial
        onResize();
      });
      ro.observe(track);
    }

    // Autoplay opcional, solo si el contenedor lo declara.
    root.setAttribute('aria-roledescription', 'carrusel');
    var apTimer = null, apMs = parseInt(root.getAttribute('data-lc-autoplay'), 10);
    // Por defecto el sistema manda; con data-lc-autoplay-force la tienda decide rotar igual
    // (el cambio de slide ya es instantaneo bajo 'reducir movimiento', ver go()).
    var force = root.hasAttribute('data-lc-autoplay-force');
    var apStart = function () {}, apStop = function () {};
    if (apMs > 0 && (!REDUCE || force)) {
      apMs = apMs * 1000;
      apStart = function () { if (!apTimer) apTimer = setInterval(function () { if (state.loop) go(1); }, apMs); };
      apStop = function () { clearInterval(apTimer); apTimer = null; };
      apStart();
      root.addEventListener('mouseenter', apStop);
      root.addEventListener('mouseleave', apStart);
      root.addEventListener('focusin', apStop);
      root.addEventListener('focusout', apStart);
    }

    // Limpieza para el editor de temas (evita fugas de timers/listeners al recargar la seccion).
    root.__lcCleanup = function () {
      clearTimeout(settleTimer);
      clearTimeout(resizeTimer);
      apStop();
      window.removeEventListener('resize', onResize);
      window.removeEventListener('load', onLoad);
      track.removeEventListener('scroll', onScroll);
      root.removeEventListener('mouseenter', apStop);
      root.removeEventListener('mouseleave', apStart);
      root.removeEventListener('focusin', apStop);
      root.removeEventListener('focusout', apStart);
      if (ro) ro.disconnect();
    };
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-lc-root]');
    for (var i = 0; i < nodes.length; i++) initRoot(nodes[i]);
  }

  window.LitteCarousel = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Editor de temas: secciones que se recargan en caliente.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target || !e.target.querySelectorAll) return;
    var nodes = e.target.querySelectorAll('[data-lc-root]');
    for (var i = 0; i < nodes.length; i++) { if (nodes[i].__lcCleanup) nodes[i].__lcCleanup(); }
  });
})();
